<template>
  <b-form-input
    id="bottleAmount"
    v-model.number="vModel"
    type="number"
    :placeholder="$t('questions.bottleAmount')"
  ></b-form-input>
</template>
<script>
import { InputField } from '../Input.mixin'

export default {
  name: 'InputBottleAmount',
  extends: InputField
}
</script>
